if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (enableSlider) {
        this.initSlider();
        return;
      }
      this.initMarquee();
    }

    initMarquee() {
      const inner = this.querySelector(".m-announcement-bar__inner");
      if (!inner) return;
      const setDuration = () => {
        const trackWidth = inner.scrollWidth;
        if (trackWidth < 2) return;
        const pxPerSecond = 80;
        const duration = Math.max(10, trackWidth / 2 / pxPerSecond);
        inner.style.setProperty("--ag-marquee-duration", `${duration}s`);
      };
      setDuration();
      requestAnimationFrame(setDuration);
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
